import { defineStore } from 'pinia';
import { collection, onSnapshot } from 'firebase/firestore';
import { firestore } from '@/firebase';

export const usePaymentMethodStore = defineStore('paymentMethod', {
  state: () => ({
    paymentMethods: {},
    unsubs: [],
  }),
  persist: { paths: ['paymentMethods'] },
  getters: {
    allPaymentMethods(state) {
      return Object.values(state.paymentMethods).sort((a, b) => {
        const orderA = Number(a.order) || 0;
        const orderB = Number(b.order) || 0;
        if (orderA !== orderB) return orderA - orderB;
        return (a.name || '').localeCompare(b.name || '');
      });
    },
    defaultPaymentMethod() {
      const methods = this.allPaymentMethods;
      return methods.find((m) => m.isDefault) || methods[0] || null;
    },
    defaultFeePercent() {
      const method = this.defaultPaymentMethod;
      return method ? Number(method.feePercent) || 0 : 0;
    },
  },
  actions: {
    upsert({ id, value }) {
      this.paymentMethods = { ...this.paymentMethods, [id]: value };
    },
    remove(id) {
      const paymentMethods = { ...this.paymentMethods };
      delete paymentMethods[id];
      this.paymentMethods = paymentMethods;
    },
    clearUnsubs() {
      for (const unsub of this.unsubs) {
        if (typeof unsub === 'function') unsub();
      }
      this.unsubs = [];
    },
    clear() {
      this.clearUnsubs();
      this.paymentMethods = {};
    },
    registerSnapshot() {
      this.clearUnsubs();
      const snapshotQuery = collection(firestore, 'paymentMethods');
      const unsub = onSnapshot(
        snapshotQuery,
        (snapshot) => {
          snapshot.docChanges().forEach((element) => {
            const elementData = { ...element.doc.data() };
            elementData.id = element.doc.id;
            if (element.type === 'added' || element.type === 'modified') {
              this.upsert({ id: element.doc.id, value: elementData });
            } else {
              this.remove(element.doc.id);
            }
          });
        },
        (error) => {
          console.error('PaymentMethod - Error registering snapshot', error);
        }
      );
      this.unsubs.push(unsub);
    },
  },
});
